import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { Router } from '@angular/router';

import { RoutePathEnum } from '@connect-services/client/models/routes.model';
import { WarehouseAndFormsAccessPermissionsService } from '@connect-services/client/services/warehouse-and-forms-access-permissions.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-data-button',
    templateUrl: './data-button.component.html',
})
export class DataButtonComponent {
    protected readonly canAccessDataButton: Signal<boolean> = computed(() =>
        this.warehouseAndFormsAccessPermissionsService.canAccessData(),
    );
    protected readonly RoutePathEnum = RoutePathEnum;

    private readonly router = inject(Router);
    private readonly warehouseAndFormsAccessPermissionsService = inject(WarehouseAndFormsAccessPermissionsService);

    public redirectToManagementDataPanel(): void {
        if (!this.canAccessDataButton()) {
            return;
        }

        if (this.router.url.includes(RoutePathEnum.MANAGEMENT_DATA)) {
            return;
        }

        this.router.navigate([RoutePathEnum.MANAGEMENT_DATA]);
    }
}
